export default "__VITE_ASSET__DjzC8E4K__"